import {Key, TablePaginationConfig, TableRowSelection} from 'antd/es/table/interface';
import {Key as ReactKey} from 'react';

import {ITableEntityMeta} from 'entities/metadata';
import {performActionForTableState, setData} from 'modules/data/data-actions';
import {IDefaultTableState, TEntity, ITableEntityData} from 'modules/data/data-types';
import {EEntityType} from 'shared/constants/entities';
import {checkWatchersDisabled} from 'shared/hooks/use-table-cell-watcher';
import {useAppDispatch} from 'store/config/hooks';

import {convertObjectToTableStateFlat} from '../form-table/form-table.utils';

interface IUseTableFeaturesProps {
    entityName: string;
    url: string;
    data: ITableEntityData;
    metadata: ITableEntityMeta;
}

export const useTableFeatures = ({
    entityName, url, data, metadata,
}: IUseTableFeaturesProps) => {
    const dispatch = useAppDispatch();
    const handleTableChange = (
        pagination: TablePaginationConfig,
        filters: Record<string, Key[] | null>,
        sorter: any,
    ) => {
        dispatch(performActionForTableState({
            entityName,
            newEntityTypeData: convertObjectToTableStateFlat(
                {pagination, sorter} as IDefaultTableState,
            ) as Record<string, any>,
            prefix: metadata?.prefix ? metadata.prefix : url,
            urlConfig: metadata?.urlConfig,
        }));
    };

    const rowSelection: TableRowSelection<Record<string, TEntity[]>> = {
        selectedRowKeys: data?.selectedRowKeys,
        onChange: (
            selectedRowKeys: ReactKey[],
            selectedRows: TEntity[],
        ) => dispatch(setData({
            entityName,
            entityType: EEntityType.TABLE,
            data: {
                selectedRowKeys,
                selectedRows,
            },
        })),
        getCheckboxProps: (record: TEntity) => ({
            disabled: checkWatchersDisabled(metadata?.rowSelectionWatchers, record, data?.rows || []),
        }),
    };

    return {handleTableChange, rowSelection};
};
